export default __webpack_public_path__ + "static/media/copres.5c46ef1d.jpg";